import { useEffect, useState } from 'react';
import { getLocalStorageUserSuffix } from '~/utils/local-storage.client';

/**
 * Hook that retrieves the local storage suffix.
 * Re-fetches when isLoggedIn changes to ensure suffix is available after login.
 *
 * @param isLoggedIn - The login state to trigger re-fetching
 */
export function useLocalStorageSuffix(
  isLoggedIn: boolean | null
): string | null {
  const [localStorageSuffix, setLocalStorageSuffix] = useState<string | null>(
    null
  );

  useEffect(() => {
    if (!isLoggedIn) {
      setLocalStorageSuffix(null);
      return;
    }

    const getLocalStorageSuffix = async (): Promise<void> => {
      const suffix = await getLocalStorageUserSuffix();

      if (suffix) {
        setLocalStorageSuffix(suffix);
      }
    };

    getLocalStorageSuffix();
  }, [isLoggedIn]);

  return localStorageSuffix;
}
